import { GenericTime, Time } from './time';

/** @see OTT-82541 if need hide preroll timeline */
export class Duration implements GenericTime<'duration'> {
    public visibleDuration: number;

    constructor(public streamDuration: number, private prerollDuration: number = 0) {
        this.visibleDuration = this.streamDuration - this.prerollDuration;
    }

    getTimeFromPercent(percent: number) {
        return new Time(
            percent * this.visibleDuration + this.prerollDuration,
            this.prerollDuration
        );
    }

    getPercentFromTime(time: Time) {
        return time.visibleTime / this.visibleDuration;
    }

    getSecondsTillEnd(time: Time) {
        return this.streamDuration - time.streamTime;
    }
}
